const getForm = () => ({
  colCount: 3,
  labelLocation: "top",
  items: [
    {
      text: "Nombre",
      dataField: "Name",
      label: {
        alignment: "left",
      },
      editorOptions: {
        placeholder: "Nombre",
        maxLength: 30,
      },
    },
    {
      text: "Descripción",
      colSpan: 2,
      dataField: "Description",
      label: {
        alignment: "left",
      },
      editorOptions: {
        placeholder: "Descripción",
        maxLength: 80,
      },
    },
  ],
});

export default getForm;
